export default __webpack_public_path__ + "static/media/pickles.5990c503.png";